class Preference {

    constructor(img, preference){
        this.id = img
        this.score = preference
    }

}

export default Preference